import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { imjDark, imjLight } from './imjTheme';

/*
 * Los nombres 'light' y 'dark' sobrescriben los temas por defecto
 * (`theme:app/light` y `theme:app/dark`), de modo que se conserva la
 * preferencia de tema guardada por cada usuario.
 */

const iconoClaro = (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="5" fill="currentColor" />
    <path
      d="M12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const iconoOscuro = (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
      fill="currentColor"
    />
  </svg>
);

const temaClaro = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'IMJ claro',
      variant: 'light',
      icon: iconoClaro,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={imjLight}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});

const temaOscuro = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'IMJ oscuro',
      variant: 'dark',
      icon: iconoOscuro,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={imjDark}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [temaClaro, temaOscuro],
});
